export default __webpack_public_path__ + "static/media/bg-explore-consumer.5b448e29.svg";